<template>
  <div :class=" propRegistroId ? '' : 'content--sinoreg ordemServico p-2'">
    <h4 v-if="!propRegistroId"
        class="ordemServico_title">
      Ordens de Serviços
    </h4>
    <OrdemServicoForm 
      :prop-custas="custas"
      :prop-ordem-servico="ordemServico"
      :prop-ordem-servico-sem-registro="true"
      :prop-tipo="propTipo"
      :prop-registro-id="propRegistroId"
      :prop-registro="propRegistro"
      :prop-novo="propNovo"
      :prop-novo-procedimento="!!procedimento"
      :prop-data="propData"
      :prop-procedimentos="propProcedimentos"
      :prop-pedido-pendente="propPedidoPendente"
      :prop-pedido-p13="propPedidoP13"
      @solicitarImpressao="$emit('solicitarImpressao')"
      @onBack="() => this.$emit('onBack')" />
  </div>
</template>

<script>
  /* components */
  import OrdemServicoForm from '@/components/SofiaRei/Resumo/OrdensServico/ordensServicoForm/OrdensServicoForm.vue'
  /* services */
  import CustasService from '@/services/Registros/CustasService'


  // Entities
  import OrdemServico from "@/entities/OrdemServico/OrdemServico"
  import { mapGetters } from 'vuex'

  export default {
    name: 'OrdensServico',
    components: {
      OrdemServicoForm
    },
    props: {
      propPedidoP13: {type: Object, default: () => {}},
      propPedidoPendente: {type: Object, default: () => {}},
      propOrdemServico: { type: Object, default: null }, // 
      propData: { type: Object, default: null },
      propAcao: { type: String, default: null },
      propRegistroId: { type: Number, default: null }, // Registro
      propRegistro: { type: Object, default: null }, // Registro
      propTipo: { type: String, default: null }, // Registro
      propNovo: { type: Boolean, default: false }, // Registro
      propSolicitante: { type: Object, default: null }, // Registro
      propGerarCpf: { type: Boolean, default: false }, // Registro
      propGemeos: { type: Array, default: null}, // Registro
      propProcedimentos: { type: Boolean, default: false },
 
    },
    data () {
      return {
        custas: [],
        ordemServico: new OrdemServico(),
        pedidoPendente: {}
      }
    },
    computed: {
      ...mapGetters({
        cartorioId: 'auth/getCartorioId',
        cartorioObj: 'auth/getCartorioObj',
        procedimento: 'procedimento/getProcedimento',
        solicitanteProcedimento: 'procedimento/getRequerente'
      })

    },
    watch: {
      propOrdemServico (novoValor) {
        if (Object.keys(novoValor).length) {
          this.ordemServico = new OrdemServico(novoValor)
        }
      }
    },

    async beforeMount () {
      try {
        loader({ text: 'Carregando custas', active: true })
        await this.getCustas()  
        loader({ text: '', active: false })


      } catch (e) {
        loader({ text: '', active: false })
        console.error(e)
        this.$router.push('/pagina-nao-encontrada')
      }
    },


    created () {
      if (this.propOrdemServico) {
        this.ordemServico = new OrdemServico(this.propOrdemServico)
      }
      if (this.propRegistroId) {
        this.ordemServico.registro_id = this.propRegistroId
      }
      
      if (this.propRegistro || this.solicitanteProcedimento) {
        this.getSolicitante()
      }

      if (this.propOrdemServico) {
        if (!!this.propOrdemServico.cpf_solicitante) {
          this.ordemServico.cpf_solicitante = this.propOrdemServico.cpf_solicitante
        }

        if (!!this.propOrdemServico.nome_solicitante) {
          this.ordemServico.nome_solicitante = this.propOrdemServico.nome_solicitante
        }

        if (!!this.propOrdemServico.num_pedido_crc) {
          this.ordemServico.num_pedido_crc = this.propOrdemServico.num_pedido_crc
        }     
      }

    },
    methods: {
      async getCustas () {
        const custas =  await CustasService.getCustas({
          cartorio_id: this.cartorioObj.cartorio_id,
          perPage: 200,
          os: 1,
          ativo: true
        })
        this.custas = custas.data
        this.$store.dispatch('custa/setCustasAtivas', this.custas)   
      },

      getSolicitante () {
        if (!!this.solicitanteProcedimento  && !!this.procedimento) {
          const { nome, cpf } = this.solicitanteProcedimento
          this.ordemServico.nome_solicitante = nome
          this.ordemServico.cpf_solicitante = cpf
          return
        }
        if (!!this.propRegistro.ordemServico.length) {
          const length = this.propRegistro.ordemServico.length
          const { cpf_solicitante, nome_solicitante } = this.propRegistro.ordemServico[length - 1]
          this.ordemServico.nome_solicitante = nome_solicitante
          this.ordemServico.cpf_solicitante = cpf_solicitante
          return
        }
      }
    
    }
  }
</script>

<style lang="scss" scoped>
  @import "@/scss/_utilities/_exports";

  .ordemServico {
    &_title {
      background-color: $sinoreg-blue;
      color: $color-white;
      font-size: pxToRem(24);
      font-weight: 500;
      padding: pxToRem(10) pxToRem(20);
    }

    &_label {
      font-size: pxToRem(16);
    }
  }
</style>
